import { useMemo } from 'react'
import { toast as uiToast, useToast as useUiToast } from '@/components/ui/use-toast'

type ToastType = 'info' | 'success' | 'warning' | 'error'

type ToastPayload = {
  title: string
  message?: string
  description?: string
  type?: ToastType
  duration?: number
  variant?: 'default' | 'destructive'
}

const mapVariant = (type?: ToastType) => {
  if (type === 'error' || type === 'warning') return 'destructive'
  return 'default'
}

export function useToast() {
  const ui = useUiToast()

  const toast = (notification: ToastPayload) => {
    uiToast({
      title: notification.title,
      description: notification.description ?? notification.message,
      variant: notification.variant ?? mapVariant(notification.type),
      duration: notification.duration,
    })
  }

  const api = useMemo(() => ({
    toast,
    success: (title: string, message: string) => toast({ title, message, type: 'success' }),
    error: (title: string, message: string) => toast({ title, message, type: 'error' }),
    warning: (title: string, message: string) => toast({ title, message, type: 'warning' }),
    info: (title: string, message: string) => toast({ title, message, type: 'info' }),
    dismiss: ui.dismiss,
  }), [ui.dismiss])

  return api
}
